import Vue from 'vue';
import Router from '@/router';

// 数据接收
window.addEventListener(
  'message',
  function(e) {
    if (e.data) {
      try {
        const data = JSON.parse(e.data);
        if (data.method === 'search') {
          if (Router.history.current.name === 'searchList') {
            Router.push({
              name: 'searchList',
              params: {
                keyWord: data.keyword,
              },
              query: {
                t: new Date().getTime(),
              },
            });
          } else {
            Router.push({
              name: 'searchList',
              params: {
                keyWord: data.keyword,
              },
            });
          }
          console.log('素材库进行搜索');
        } else if (data.method === 'track') {
          const obj = {
            ...data.data,
          };
          console.log('埋点数据上报');
          obj.trackData.searchTimeStart = new Date().getTime();
          Vue.prototype._track(obj.trackData);
        }
      } catch (error) {
        // console.log(error);
      }
    }
  },
  false
);

// 数据发送
export const sendData = function(data) {
  console.log('往iframe发送数据', data);
  window.parent.postMessage(JSON.stringify(data), '*');
};
